import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import jwtDecode from "jwt-decode";
import { Document, Page } from 'react-pdf';
import { useParams } from "react-router-dom";

import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';


const Statement = () => {
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const { monthYear } = useParams();

  const [selectedYear, setSelectedYear] = useState( monthYear ? monthYear.split('-')[1] : "" );
  const [selectedMonth, setSelectedMonth] = useState( monthYear ? ( ( monthYear.split('-')[0] < 10 ? "0" : "" ) + monthYear.split('-')[0]  ) : "" );

  const [initialLoaded, setInitialLoaded] = useState(false);
  
  const [userId, setUserId] = useState("");
  const [currentPdf, setCurrentPdf] = useState(null);

  const [filesData, setFilesData] = useState(null);

  const [docWidth, setDocWidth] = useState(window.innerWidth * 0.9);

  // on resize chagne doc width
  useEffect(() => {
    const handleResize = () => {
      setDocWidth(window.innerWidth * 0.9);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Fetch user ID from JWT token
  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      const decoded = jwtDecode(token);
      setUserId(decoded.user); // Extract the user ID
    }
  }, []);

  // Fetch available statements and populate dropdowns
  useEffect(() => {
    const fetchStatements = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASEURL}/statements/${localStorage.getItem("currentUser")}`, {
          // Set authorization header
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        });
        const files = await response.json();

        const uniqueYears = Object.keys( files );

        // Sort unique years in descending order
        uniqueYears.sort((a, b) => b - a);
        
        // Extract unique years and months from user files
        setYears(uniqueYears);

        // Set current year to the first year in the list
        if ( uniqueYears.length > 0 && ! selectedYear ) {
          setSelectedYear(uniqueYears[0]);
        }

        setFilesData(files);

        if (selectedYear) {
          const uniqueMonths = [
            ...new Set(
              Object.keys( files[selectedYear] )
            ),
          ];
          setMonths(uniqueMonths);
        }

        if ( ! initialLoaded && selectedMonth && selectedYear ) {
          setInitialLoaded(true);
        }

      } catch (error) {
        console.error("Error fetching statements:", error);
      }
    };

    fetchStatements();
  }, [userId, selectedYear]);

  // Update PDF when year and month are selected
  useEffect(() => {
    const fetchCurrentPdf = async () => {
      if (filesData && selectedYear && selectedMonth && filesData[selectedYear] && filesData[selectedYear][selectedMonth] ) {
        try {
          // Find the matching PDF for the selected year and month
          setCurrentPdf(`${process.env.REACT_APP_API_BASEURL}/assets/documents/statements/${filesData[selectedYear][selectedMonth][0].fileName}`);
        } catch (error) {
          console.error("Error fetching PDF:", error);
        }
      } else {
        setCurrentPdf(null);
      }
    };

    fetchCurrentPdf();
  }, [selectedYear, selectedMonth, initialLoaded]);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs';

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Statement</a>
          </div>
          <div id="result-wrapper">
            <div id="searchbar">
              <table>
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <h2>Search Statements</h2>
                    </td>
                  </tr>
                  <tr>
                    <td className="inputs">
                      <select
                        id="ddlYear"
                        name="Year"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        <option value="">Year</option>
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="inputs">
                      <select
                        id="ddlMonth"
                        name="Month"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        disabled={!selectedYear} // Disable until year is selected
                      >
                        <option value="">Month</option>
                        {months.map((month) => (
                          <option key={month} value={month}>
                            {new Date(0, month - 1).toLocaleString("default", { month: "long" })}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="pdf-viewer">
              {currentPdf ? (
                <>
                  <Document
                    file={currentPdf}
                    
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  >
                    {/* For each page in the PDF, render a Page component */}
                    {Array.from({ length: numPages }, (_, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} width={docWidth} />
                    ))}
                  </Document>
                  {/* <iframe src={currentPdf} width="100%" height="600px" title="Statement PDF"></iframe> */}
                </>
              ) : (
                <p>No PDF selected or available for the selected year and month.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Statement;
